import React from 'react'
import { Redirect, Route } from 'react-router'
import { useAsync } from 'react-use'

import Loader from 'common/components/Loader'

export const GuardedRoute = React.memo(({ guards, redirectTo, component: Component, name, ...route }) => {
  React.useEffect(() => {
    return () => null
  }, [])
  if (!guards || !redirectTo || !Component || !route.path) throw new Error('Você passou alguma coisa errada nas props ')

  const { value: availableGuards, loading } = useAsync(
    async () => await Promise.all(guards.map((guard) => guard())).then((response) => response),
    [guards],
  )

  if (loading) {
    return <Loader />
  }

  return (
    <Route
      {...route}
      render={(props) => {
        window.document.title = `${name} | Plataforma Blox`
        return availableGuards.every((result) => result === true) ? (
          <Component {...props} />
        ) : (
          <Redirect to={redirectTo} />
        )
      }}
    />
  )
})
